import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { AutoOutgoingRule } from '../../../models/auto-outgoing-rule';

import { AutoOutgoingRuleService } from '../../../services/auto_rules/auto-outgoing-rule.service';
import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-auto-outgoing-rule-form',
  templateUrl: './auto-outgoing-rule-form.component.html',
  styleUrls: ['./auto-outgoing-rule-form.component.scss'],
})
export class AutoOutgoingRuleFormComponent implements OnInit {
  autoOutgoingRuleId: number;

  autoOutgoingRule: AutoOutgoingRule = new AutoOutgoingRule();

  formOptions: any = {};

  loading: boolean = true;

  saving: boolean = false;

  constructor(private notyService: NotyService, private location: Location, private route: ActivatedRoute, private router: Router, private autoOutgoingRuleService: AutoOutgoingRuleService) {}

  // Component lifecycle methods
  ngOnInit() {
    this.loading = true;
    this.autoOutgoingRuleService.formOptions().then((response_json) => {
      this.loading = false;
      this.formOptions = response_json;
      this.autoOutgoingRuleId = this.route.snapshot.params['id'];
      if (this.autoOutgoingRuleId)
        this.autoOutgoingRuleService.edit(this.autoOutgoingRuleId).then((response_json) => {
          this.autoOutgoingRule = response_json.auto_outgoing_rule;
        });
    });
  }

  // Component methods
  back() {
    this.location.back();
  }

  save() {
    this.saving = true;
    this.autoOutgoingRuleService
      .save(this.autoOutgoingRule)
      .then((response_json) => {
        this.saving = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Auto outgoing rule saved', 'success');
          this.router.navigateByUrl('/auto_outgoing_rules');
        } else this.notyService.notify(response_json.text || 'Error saving auto outgoing rule', 'error');
      })
      .catch(() => {
        this.saving = false;
        this.notyService.notify('Error saving auto outgoing rule', 'error');
      });
  }
}
